import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { ActionLoaderComponent } from '../action-loader/action-loader.component';
import { NotificationService } from '../notification.service';
import { PanelService } from '../../panel/panel.service';
import { User } from '../../users/users.model';

@Component({
  selector: 'app-dialog-notification',
  templateUrl: './dialog-notification.component.html',
  styleUrls: ['./dialog-notification.component.scss']
})
export class DialogNotificationComponent implements OnInit {
  @ViewChild('sendNotificationLoader')
  public sendNotificationLoader: ActionLoaderComponent;

  public notificationForm: FormGroup;

  constructor(
    private readonly fb: FormBuilder,
    private readonly panelService: PanelService,
    private readonly notificationService: NotificationService,
    public dialogRef: MatDialogRef<DialogNotificationComponent>
  ) {}

  ngOnInit(): void {
    this.buildForm();
    this.setupFormListeners();
    this.setInitialDisabledState();
  }

  public get isFormValid(): boolean {
    const form = this.notificationForm;
    if (!form.valid) {
      return false;
    }

    const recipientType = form.get('recipientType').value;
    if (recipientType === 'specific') {
      const users = form.get('selectedUsers').value;
      return users && users.length > 0;
    }
    return true;
  }

  public onSend(): void {
    if (!this.isFormValid) {
      return;
    }

    this.sendNotificationLoader.start();

    const formValue = this.notificationForm.getRawValue();
    const userIds = formValue.recipientType === 'all'
      ? []
      : formValue.selectedUsers.map((u: User) => u.id);

    this.panelService.sendNotification(
      userIds,
      formValue.title,
      formValue.description
    )
      .then(() => {
        this.notificationService.success('Notificación enviada exitosamente');
        this.dialogRef.close(true);
      })
      .catch((error) => {
        this.notificationService.error(error);
      })
      .finally(() => {
        this.sendNotificationLoader.stop();
      });
  }

  public onCancel(): void {
    this.dialogRef.close(false);
  }

  private buildForm(): void {
    this.notificationForm = this.fb.group({
      recipientType: ['all', Validators.required],
      selectedUsers: [[]],
      title: ['', Validators.required],
      description: ['', Validators.required]
    });
  }

  private setupFormListeners(): void {
    this.notificationForm.get('recipientType').valueChanges
      .subscribe(type => {
        const usersControl = this.notificationForm.get('selectedUsers');
        if (type === 'all') {
          usersControl.disable();
          usersControl.clearValidators();
        } else {
          usersControl.enable();
          usersControl.setValidators([Validators.required]);
        }
        usersControl.updateValueAndValidity();
      });
  }

  private setInitialDisabledState(): void {
    setTimeout(() => {
      this.notificationForm.get('selectedUsers').disable();
    });
  }
}

